import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-global-device-auth",
  "use": "icon-soc-l1-global-device-auth-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-l1-global-device-auth\">\n  <!-- ??????????? + ??? -->\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <circle cx=\"448\" cy=\"512\" r=\"288\" />\n    <path d=\"M160 512h576M448 224c96 96 144 192 144 288s-48 192-144 288M448 224c-96 96-144 192-144 288s48 192 144 288\" />\n    <path d=\"M704 288l160 56v96c0 88-56 156-160 200-104-44-160-112-160-200v-96l160-56z\" />\n    <path d=\"M704 416v96c0 40 24 72 64 96\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-global-device-auth.svg
// module id = t/ba
// module chunks = 488